import { useEffect, useState, useRef } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useBetween } from "use-between";

import "./index.scss";
import useShopify from "../../../useShopify";
import Logo from "../../../assets/images/boxfox.png";
import LogoMobile from "../../../assets/images/boxfox-mobile.svg";
import Back from "../../../components/back";
import LogoNew from "../../../assets/images/boxfox-new.png";
import WizBG from "../../../assets/images/wiz-bg.png";
import WizButton from "../../../components/wiz/wiz-button";
import WizBoxfoxLogo from "../../../assets/images/wiz-boxfox.png";
import WizHooray from "../../../assets/images/wiz-hooray.png";
import PhiloDarkLogo from "../../../assets/images/philo-dark.png";

const Gifts = ({
  prev,
  next,
  gotoCheckout,
  selectionState,
  updateSelectionState,
  hasShownWelcomeModal,
  setHasShownWelcomeModal,
  form,
  setForm
}) => {
  const { product, products, campaign, setProduct, note, setNote, setImage } =
    useBetween(useShopify);

  const isRegent = campaign.companyId === process.env.REACT_APP_REGENT_COMPANY_ID;
  const isEncore = campaign.companyId === "65cd150fdc2cf13513530120";
  const is1011 = campaign.companyId === "6530617ad257c395c2f9a961";
  const isLiveNation = campaign.companyId === "65d52364dc2cf135135301fd";
  const isLiveNationCampaign2024 = campaign.name === "Live Nation Event Client Gifting 2024";
  const isModernHealth = campaign.companyId === "67294a3bdca127a271571be4" || campaign.companyId === "68fa77f6cee86b5fec95da46";
  const isConcentrix = campaign.companyId === "67981cfbdca127a271575000";
  const isWiz = campaign.companyId === "67981cfbdca127a271575000";
  const isEdwardsLS = campaign.companyId === "67f6b6badca127a27157640b";
  const isImpiricus = campaign.companyId === "66639212d7476d285f2b1cfe";
  const isCyera = campaign.companyId === "6840f57ecee86b5fec9562c6";
  const isNewGusto = campaign.companyId === "68c3332bcee86b5fec9588ab";
  const isPhilo = campaign.companyId === "653186e9d257c395c2f9aaa2";
  const isCyeraSecretSanta2 = campaign.name === "CYERA SECRET SANTA GIFTS";

  const isPlenty = campaign.companyId === "696aaa2dcee86b5fec96369d";

  // Detect Grand Asia Exploration or Indian Odyssey for Regent copy
  const normalizedCampaignNameForDisplay = (campaign?.name || '').toLowerCase().replace(/[-\s]/g, '');
  const isGrandAsiaCampaign = normalizedCampaignNameForDisplay.includes('grandasia') || normalizedCampaignNameForDisplay.includes('grandasianexploration') || normalizedCampaignNameForDisplay.includes('indianodyssey');
  const isWorldCruiseDisplay = normalizedCampaignNameForDisplay.includes('worldcruise2026') || normalizedCampaignNameForDisplay.includes('worldcruise2027');
  // World Cruise 2027: each guest picks a polo, a jacket or vest, then a hat or belt bag (option 2).
  const isWorldCruise2027 = isRegent && normalizedCampaignNameForDisplay.includes('worldcruise2027');
  const isAccessoryOption = (optionIndex) => isWorldCruise2027 && optionIndex === 2;
  // World Cruise 2027 products are classified by title rather than exact handles:
  // polo, vest, jacket, or accessory (hat / bag, no size), and female if it says "women".
  // Title only: some reused Shopify products keep an old handle (e.g. a "-vest-womens" handle on a men's jacket).
  const getWorldCruise2027Kind = (item) => {
    const text = (item?.title || item?.handle || '').toLowerCase();
    const type = text.includes('polo') ? 'polo' : text.includes('vest') ? 'vest' : text.includes('jacket') ? 'jacket' : 'accessory';
    const gender = /women|female|ladies/.test(text) ? 'Female' : 'Male';
    return { type, gender };
  };
  const isWorldCruiseAccessory = (item) => getWorldCruise2027Kind(item).type === 'accessory';
  // Option 0: polo, option 1: jacket or vest, option 2: hat or bag.
  // No gender picker: men's and women's versions are shown side by side.
  const matchesWorldCruise2027Option = (item, optionIndex) => {
    const kind = getWorldCruise2027Kind(item);
    if (optionIndex === 2) return kind.type === 'accessory';
    return optionIndex === 0 ? kind.type === 'polo' : (kind.type === 'vest' || kind.type === 'jacket');
  };
  const worldCruiseOptionLabels = ["Polo", "Jacket or Vest", "Hat or Belt Bag"];
  // Product shown in the description + size chart popup (World Cruise 2027); null when closed.
  const [infoProduct, setInfoProduct] = useState(null);

  const [desc, setDesc] = useState("");
  const [includes, setIncludes] = useState("");
  const [details, setDetails] = useState("");
  const [showRequiredField, setShowRequiredField] = useState(false);
  const [finalSortedProducts, setFinalSortedProducts] = useState(products);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedGenders, setSelectedGenders] = useState({});
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  const plentyAutoSkipDone = useRef(false);

  const {
    skuOptions,
    sizeOptions,
    genderOptions,
    selections,
    currentGenderIndex,
    currentOptionIndex,
    selectedSizes,
    isSelectionOpen,
  } = selectionState;

  // Add isMobile detection
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  // Add game choice state
  const [gameChoice, setGameChoice] = useState("");

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  //REGENT "66d10d42a6ecf67d94f0f7c0";

  useEffect(() => {
    if (isRegent && skuOptions?.length > 0) {
      console.log('Regent products filtering:', {
        isRegent,
        skuOptions,
        products,
        product,
        campaignName: campaign.name,
        campaignId: campaign.companyId
      });
      
      // Normalize campaign name for comparison
      const normalizedCampaignName = campaign.name.toLowerCase().replace(/[-\s]/g, '');
      const isArcticCampaign = normalizedCampaignName.includes('grandarctic');
      const isWorldCruise = normalizedCampaignName.includes('worldcruise2026') || normalizedCampaignName.includes('worldcruise2027');
      const isCulturalCampaign = normalizedCampaignName.includes('grandculturalquest');
      const isContinentalCampaign = normalizedCampaignName.includes('grandcontinental');
      const isAsiaCampaign = normalizedCampaignName.includes('grandasia') || normalizedCampaignName.includes('grandasianexploration') || normalizedCampaignName.includes('indianodyssey');
      // Grand Asia 2026 reuses the Grand Arctic products (Indian Odyssey / Grand Asian Exploration keep their own).
      const isGrandAsia2026 = normalizedCampaignName.includes('grandasia2026');

      console.log('Campaign detection:', {
        campaignName: campaign.name,
        normalizedCampaignName,
        isArcticCampaign,
        isCulturalCampaign,
        isWorldCruise,
        isContinentalCampaign,
        isAsiaCampaign
      });

      const arcticSkus = [
        'eddie-bauer-mens-fleece-vest-grand-arctic',
        'port-authority-womens-core-soft-shell-vest-grand-arctic',
        'mens-sport-tek-full-zip-wind-jacket-grand-arctic',
        'port-authority-zephyr-full-zip-jacket-grand-arctic'
      ];

      const culturalSkus = [
        'mens-sport-tek-full-zip-wind-jacket-grand-quest',
        'eddie-bauer-mens-fleece-vest-grand-quest',
        'port-authority-womens-core-soft-shell-vest-grand-quest',
        'port-authority-zephyr-full-zip-jacket-grand-quest'
      ];

      const continentalSkus = [
        'eddie-bauer-mens-fleece-vest-grand-continental',
        'port-authority-womens-core-soft-shell-vest-grand-continental',
        'mens-sport-tek-full-zip-wind-jacket-grand-continental',
        'port-authority-zephyr-full-zip-jacket-grand-continental'
      ];

      const asiaSkus = [
        'grand-asia-vest-mens',
        'grand-asia-vest-women',
        'grand-asia-insulated-jacket-mens',
        'grand-asia-insulated-jacket-womens'
      ];

      const worldCruiseSkus = [
        'world-cruise-travis-mathew-polo',
        'world-cruise-travis-mathew-polo-womens',
        'world-cruise-eddie-bauer-vest-mens',
        'world-cruise-eddie-bauer-vest-womens',
        'world-cruise-insulated-jacket-mens',
        'world-cruise-insulated-jacket-womens'
      ];

      const targetSkus = isWorldCruise
        ? worldCruiseSkus
        : (isArcticCampaign || isGrandAsia2026)
          ? arcticSkus
          : isCulturalCampaign
            ? culturalSkus
            : isContinentalCampaign
              ? continentalSkus
              : isAsiaCampaign
                ? asiaSkus
                : continentalSkus;

      console.log('Available products:', products.map(p => p.handle));
      console.log('Target SKUs:', targetSkus);

      const filteredProducts = products.filter((product) => {
        if (!product) return false;
        // Hide sold out items
        if (product?.availableForSale === false) {
          return false;
        }
        const productHandle = product.handle.toLowerCase();
        // Every World Cruise 2027 campaign product is part of the selection.
        if (isWorldCruise2027) return true;
        const matches = targetSkus.some(sku => {
          const match = productHandle.includes(sku.toLowerCase());
          console.log('Checking product:', {
            productHandle,
            sku,
            match
          });
          return match;
        });
        return matches;
      });

      console.log('Filtered products:', filteredProducts);
      setFilteredProducts(filteredProducts);

      if (!product && filteredProducts.length > 0) {
        setProduct(filteredProducts[0]);
      }
    } else {
      if (isModernHealth) {
        // Filter out sold out items
        const availableProducts = products.filter(product => product?.availableForSale !== false);
        const declineGiftProduct = {
          handle: "decline-gift",
          title: "Decline Gift",
          images: [],
          description: "You have chosen to decline the gift",
          descriptionHtml: "<p>You have chosen to decline the gift</p>",
        };
        setFilteredProducts([...availableProducts, declineGiftProduct]);
      } else {
        // Hide sold out items for all companies
        const filteredProducts = products.filter(product => {
          // Hide sold out items
          if (product?.availableForSale === false) {
            return false;
          }
          return true;
        });
        setFilteredProducts(filteredProducts);
      }
    }
  }, [isRegent, products, skuOptions, product, setProduct, isModernHealth, isEdwardsLS, campaign.name]);

  // Ensure correct list appears per option/gender for World Cruise
  useEffect(() => {
    if (!isRegent) return;

    const normalizedCampaignName = (campaign?.name || '').toLowerCase().replace(/[-\s]/g, '');
    const isWorldCruise = normalizedCampaignName.includes('worldcruise2026') || normalizedCampaignName.includes('worldcruise2027');
    if (!isWorldCruise) return;

    const currentSkuOption = skuOptions?.[currentGenderIndex]?.[currentOptionIndex];
    const gender = selectedGenders?.[`${currentGenderIndex}-${currentOptionIndex}`];
    const isOuterwearOption = currentOptionIndex === 1;

    const worldCruiseProducts = {
      male: {
        polo: 'world-cruise-travis-mathew-polo',
        vest: 'world-cruise-eddie-bauer-vest-mens',
        jacket: 'world-cruise-insulated-jacket-mens'
      },
      female: {
        polo: 'world-cruise-travis-mathew-polo-womens',
        vest: 'world-cruise-eddie-bauer-vest-womens',
        jacket: 'world-cruise-insulated-jacket-womens'
      }
    };

    if (isWorldCruise2027) {
      setFilteredProducts(products.filter(p =>
        p && p?.availableForSale !== false && matchesWorldCruise2027Option(p, currentOptionIndex)
      ));
      return;
    }

    let relevantSkus = [];
    if (gender === 'Female') {
      relevantSkus = isOuterwearOption
        ? [worldCruiseProducts.female.vest, worldCruiseProducts.female.jacket]
        : [worldCruiseProducts.female.polo];
    } else if (gender === 'Male') {
      relevantSkus = isOuterwearOption
        ? [worldCruiseProducts.male.vest, worldCruiseProducts.male.jacket]
        : [worldCruiseProducts.male.polo];
    } else if (currentSkuOption) {
      relevantSkus = currentSkuOption.toLowerCase().split(' or ').map(s => s.trim());
    } else {
      relevantSkus = [
        worldCruiseProducts.male.polo,
        worldCruiseProducts.female.polo,
        worldCruiseProducts.male.vest,
        worldCruiseProducts.male.jacket,
        worldCruiseProducts.female.vest,
        worldCruiseProducts.female.jacket,
      ];
    }

    const list = products.filter(p => {
      if (!p) return false;
      // Hide sold out items
      if (p?.availableForSale === false) {
        return false;
      }
      const handle = (p?.handle || '').toLowerCase();
      return relevantSkus.some(sku => handle.includes(sku));
    });
    setFilteredProducts(list);
  }, [isRegent, campaign?.name, currentGenderIndex, currentOptionIndex, selectedGenders, skuOptions, products]);

  // Size slots per guest: 2 for most voyages, 3 for World Cruise 2027 (polo, outerwear, accessory).
  const sizeStride = Math.max(2, ...(skuOptions || []).map(options => options?.length || 0));

  // Helper function to calculate size index
  const calculateSizeIndex = (genderIndex, optionIndex) => {
    // Use the same calculation as in the address page
    const sizeIndex = genderIndex * sizeStride + optionIndex;
    // console.log(`Calculating size index for gender ${genderIndex}, option ${optionIndex}: ${sizeIndex}`);
    return sizeIndex;
  };

  // Initialize selections when skuOptions change
  useEffect(() => {
    if (isRegent && skuOptions?.length > 0) {
      // console.log('Initializing selections and size options');
      // console.log('Initial skuOptions:', skuOptions);

      // Calculate total number of selections needed
      const totalSelections = skuOptions.reduce((acc, curr) => acc + (curr?.length || 0), 0);
      // console.log('Total selections needed:', totalSelections);

      // Create initial selections array
      const initialSelections = skuOptions.map(options => Array(options?.length || 0).fill(null));
      // console.log('Initial selections array:', initialSelections);

      // Create size options array with enough slots for all possible selections
      const maxSizeOptions = skuOptions.length * sizeStride;
      const initialSizeOptions = Array(maxSizeOptions).fill(["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"]);
      // console.log('Initial size options:', initialSizeOptions);

      safeUpdateSelectionState({
        selections: initialSelections,
        sizeOptions: initialSizeOptions,
        currentGenderIndex: 0,
        currentOptionIndex: 0,
        isSelectionOpen: true,
        selectedSizes: {}
      });
    }
  }, [isRegent, skuOptions]);

  const changeHandler = (event) => {
    setImage(event.target.files[0]);
  };

  useEffect(() => {
    if (Object.keys(product).length) {
      const detailsArr = product.descriptionHtml.split("<!-- split -->");
      setDesc(detailsArr[1]);
      setIncludes(detailsArr[2]);
      setDetails(detailsArr[3]);
    }
  }, [product]);

  function extractPrice(title) {
    const priceMatch = title?.match(/\$(\d+(\.\d+)?)/);
    return priceMatch ? parseFloat(priceMatch[1]) : null;
  }

  useEffect(() => {
    if (products.length > 1 && isLiveNationCampaign2024) {
      const productsWithPrices = products.map((product) => ({
        ...product,
        price: extractPrice(product?.title),
      }));

      const sortedProductsWithPrice = productsWithPrices
        .filter((product) => product.price !== null)
        .sort((a, b) => a.price - b.price);

      const productsWithoutPrice = productsWithPrices.filter(
        (product) => product.price === null
      );

      let sortedProducts =
        sortedProductsWithPrice.concat(productsWithoutPrice);

      // Hide sold out items
      sortedProducts = sortedProducts.filter(p => p?.availableForSale !== false);

      setFinalSortedProducts(sortedProducts);

      if (sortedProducts.length > 0) {
        setProduct(sortedProducts[0]);
      }
    }
  }, []);

  const safeUpdateSelectionState = (newState) => {
    if (typeof updateSelectionState === "function") {
      updateSelectionState(newState);
    } else {
      console.error(
        "updateSelectionState is not a function",
        updateSelectionState
      );
    }
  };

  const handleProductSelection = (item) => {
    if (!isRegent) {
      setProduct(item);
      // If it's Wiz and mobile, automatically proceed to next step
      if (isWiz && isMobile) {
        next();
      }
      return;
    }

    if (!skuOptions?.length || !selections) {
      console.error('skuOptions or selections not initialized');
      return;
    }

    const newSelections = [...selections];
    if (!newSelections[currentGenderIndex]) {
      newSelections[currentGenderIndex] = [];
    }
    newSelections[currentGenderIndex][currentOptionIndex] = item;

    safeUpdateSelectionState({ selections: newSelections });

    // For single selection cases, close selection immediately
    if (skuOptions?.length === 1 && skuOptions[0]?.length === 1) {
      safeUpdateSelectionState({ isSelectionOpen: false });
    } else if (skuOptions?.[currentGenderIndex]?.length > currentOptionIndex + 1) {
      safeUpdateSelectionState({
        currentOptionIndex: currentOptionIndex + 1,
      });
    } else if (skuOptions?.length > currentGenderIndex + 1) {
      safeUpdateSelectionState({
        currentGenderIndex: currentGenderIndex + 1,
        currentOptionIndex: 0,
      });
    } else {
      safeUpdateSelectionState({ isSelectionOpen: false });
    }
  };

  const openSelection = (genderIndex, optionIndex) => {
    safeUpdateSelectionState({
      currentGenderIndex: genderIndex,
      currentOptionIndex: optionIndex,
      isSelectionOpen: true,
    });
  };

  const allItemsSelected = isRegent
    ? skuOptions?.length > 0 &&
    selections?.length === skuOptions.length &&
    selections.every(
      (gender, genderIndex) =>
        skuOptions?.[genderIndex]?.length > 0 &&
        gender?.length === skuOptions[genderIndex].length &&
        gender.every((option) => option !== null)
    )
    : !!product;

  const allSizesSelected = isRegent
    ? selectedSizes &&
    selections?.length > 0 &&
    selections.flat().length > 0 &&
    Object.keys(selectedSizes).length === selections.flat().length &&
    Object.values(selectedSizes).every((size) => size !== "")
    : true;

  const allGendersSelected = isRegent
    ? selectedGenders &&
    selections?.length > 0 &&
    selections.flat().length > 0 &&
    Object.keys(selectedGenders).length === selections.flat().length &&
    Object.values(selectedGenders).every((gender) => gender !== "")
    : true;

  const canProceed = allItemsSelected;
  const canCheckout = isRegent
    ? allItemsSelected && allSizesSelected && allGendersSelected
    : isCyera && !isCyeraSecretSanta2
      ? allItemsSelected && gameChoice !== ""
      : allItemsSelected;

  const handleSizeChange = (selectionIndex, size) => {
    // console.log('Changing size for index:', selectionIndex, 'to size:', size);
    // console.log('Current selectedSizes:', selectedSizes);
    // console.log('Current sizeOptions:', sizeOptions);
    safeUpdateSelectionState({
      selectedSizes: { ...selectedSizes, [selectionIndex]: size },
    });
    
    // For non-Regent companies, also update form.size since that's what gets sent to the server
    if (!isRegent && selectionIndex === 0) {
      setForm(prevForm => ({
        ...prevForm,
        size: size
      }));
    }
  };

  const handleGenderChange = (genderIndex, optionIndex, gender) => {
    console.log('handleGenderChange called with:', { genderIndex, optionIndex, gender });
    const currentProduct = selections[genderIndex][optionIndex];

    const currentHandle = currentProduct ? currentProduct.handle.toLowerCase() : '';
    const isVest = currentHandle.includes('vest');
    const isJacket = currentHandle.includes('jacket');

    // Define product pairs based on campaign
    const normalizedCampaignName = campaign.name.toLowerCase().replace(/[-\s]/g, '');
    const isArcticCampaign = normalizedCampaignName.includes('grandarctic');
    const isWorldCruise = normalizedCampaignName.includes('worldcruise2026') || normalizedCampaignName.includes('worldcruise2027');
    const isCulturalCampaign = normalizedCampaignName.includes('grandculturalquest');
    const isContinentalCampaign = normalizedCampaignName.includes('grandcontinental');
    // Grand Asia 2026 reuses the Grand Arctic products (Indian Odyssey / Grand Asian Exploration keep their own).
    const isGrandAsia2026 = normalizedCampaignName.includes('grandasia2026');

    const arcticProducts = {
      male: {
        vest: 'eddie-bauer-mens-fleece-vest-grand-arctic',
        jacket: 'mens-sport-tek-full-zip-wind-jacket-grand-arctic'
      },
      female: {
        vest: 'port-authority-womens-core-soft-shell-vest-grand-arctic',
        jacket: 'port-authority-zephyr-full-zip-jacket-grand-arctic'
      }
    };

    const culturalProducts = {
      male: {
        vest: 'eddie-bauer-mens-fleece-vest-grand-quest',
        jacket: 'mens-sport-tek-full-zip-wind-jacket-grand-quest'
      },
      female: {
        vest: 'port-authority-womens-core-soft-shell-vest-grand-quest',
        jacket: 'port-authority-zephyr-full-zip-jacket-grand-quest'
      }
    };

    const continentalProducts = {
      male: {
        vest: 'eddie-bauer-mens-fleece-vest-grand-continental',
        jacket: 'mens-sport-tek-full-zip-wind-jacket-grand-continental'
      },
      female: {
        vest: 'port-authority-womens-core-soft-shell-vest-grand-continental',
        jacket: 'port-authority-zephyr-full-zip-jacket-grand-continental'
      }
    };

    const asiaProducts = {
      male: {
        vest: 'grand-asia-vest-mens',
        jacket: 'grand-asia-insulated-jacket-mens'
      },
      female: {
        vest: 'grand-asia-vest-women',
        jacket: 'grand-asia-insulated-jacket-womens'
      }
    };

    const worldCruiseProducts = {
      male: {
        polo: 'world-cruise-travis-mathew-polo',
        vest: 'world-cruise-eddie-bauer-vest-mens',
        jacket: 'world-cruise-insulated-jacket-mens'
      },
      female: {
        polo: 'world-cruise-travis-mathew-polo-womens',
        vest: 'world-cruise-eddie-bauer-vest-womens',
        jacket: 'world-cruise-insulated-jacket-womens'
      }
    };

    const targetProducts = isWorldCruise
      ? worldCruiseProducts
      : (isArcticCampaign || isGrandAsia2026)
        ? arcticProducts
        : isCulturalCampaign
          ? culturalProducts
          : isContinentalCampaign
            ? continentalProducts
            : asiaProducts;

    // Determine which product type to maintain (polo vs outerwear vest/jacket)
    let targetProduct;
    if (isWorldCruise) {
      // Preserve polo if currently a polo, else preserve outerwear class (vest/jacket)
      const isPolo = currentHandle.includes('polo');
      if (gender === 'Female') {
        targetProduct = isPolo ? targetProducts.female.polo : (isVest ? targetProducts.female.vest : targetProducts.female.jacket);
      } else {
        targetProduct = isPolo ? targetProducts.male.polo : (isVest ? targetProducts.male.vest : targetProducts.male.jacket);
      }
    } else {
      if (gender === 'Female') {
        targetProduct = isVest ? targetProducts.female.vest : targetProducts.female.jacket;
      } else {
        targetProduct = isVest ? targetProducts.male.vest : targetProducts.male.jacket;
      }
    }

    console.log('Switching to product:', {
      currentHandle,
      isVest,
      isJacket,
      gender,
      targetProduct,
      campaignName: campaign.name,
      isArcticCampaign,
      isCulturalCampaign
    });

    // If product is already selected, replace with corresponding gender product
    if (currentProduct) {
      const newProduct = products.find(p =>
        p.handle.toLowerCase().includes(targetProduct.toLowerCase())
      );
      if (newProduct) {
        const newSelections = [...selections];
        newSelections[genderIndex][optionIndex] = newProduct;
        safeUpdateSelectionState({
          selections: newSelections,
          isSelectionOpen: true,
          currentGenderIndex: genderIndex,
          currentOptionIndex: optionIndex
        });
      }
    }

    // Update selected gender
    const genderKey = `${genderIndex}-${optionIndex}`;
    setSelectedGenders(prev => ({ ...prev, [genderKey]: gender }));

    // Update filtered products to show all products for the selected gender
    let relevantProducts;
    if (isWorldCruise) {
      const isOuterwearOption = optionIndex === 1; // option 0: polo, option 1: outerwear
      if (gender === 'Female') {
        relevantProducts = isOuterwearOption ? [targetProducts.female.vest, targetProducts.female.jacket] : [targetProducts.female.polo];
      } else {
        relevantProducts = isOuterwearOption ? [targetProducts.male.vest, targetProducts.male.jacket] : [targetProducts.male.polo];
      }
    } else {
      relevantProducts = gender === 'Female'
        ? [targetProducts.female.vest, targetProducts.female.jacket]
        : [targetProducts.male.vest, targetProducts.male.jacket];
    }

    const genderFilteredProducts = products.filter(product => {
      if (!product) return false;
      // Hide sold out items
      if (product?.availableForSale === false) {
        return false;
      }
      const handle = product.handle.toLowerCase();
      const match = relevantProducts.some(sku => handle.includes(sku.toLowerCase()));
      if (!match) return false;
      // Extra guard for World Cruise polos: avoid cross-gender polo leakage
      if (isWorldCruise && optionIndex === 0) {
        if (gender === 'Male') return !handle.includes('polo-womens');
        if (gender === 'Female') return handle.includes('polo-womens');
      }
      return true;
    });

    console.log('Filtered products for gender:', {
      gender,
      relevantProducts,
      genderFilteredProducts: genderFilteredProducts.map(p => p.handle)
    });

    setFilteredProducts(genderFilteredProducts);
  };

  // Add a debug effect to monitor selections and sizes
  useEffect(() => {
    if (isRegent) {
      // console.log('Current state:', {
      //   selections,
      //   selectedSizes,
      //   sizeOptions,
      //   flatSelections: selections.flat(),
      //   totalSelections: skuOptions?.reduce((acc, curr) => acc + (curr?.length || 0), 0)
      // });
    }
  }, [isRegent, selections, selectedSizes, sizeOptions, skuOptions]);


  useEffect(() => {
    if (isWiz) {

      if (!hasShownWelcomeModal) {
        setShowWelcomeModal(true);
        setHasShownWelcomeModal(true);

        setProduct({});
        setDesc("");
        setIncludes("");
        setDetails("");
      }
    }
  }, [isWiz, setProduct, hasShownWelcomeModal, product]);

  // For Plenty: auto-select first product and skip to next step on mobile
  useEffect(() => {
    if (isPlenty && filteredProducts.length > 0 && !plentyAutoSkipDone.current) {
      // Auto-select the first product
      setProduct(filteredProducts[0]);
      // On mobile, skip to next step
      if (isMobile) {
        plentyAutoSkipDone.current = true;
        setTimeout(() => {
          next();
        }, 0);
      }
    }
  }, [isPlenty, isMobile, filteredProducts, setProduct, next]);

  // Add mouse tracking for image panning
  const handleMouseMove = (e) => {
    if (isWiz) {
      const rect = e.currentTarget.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      e.currentTarget.style.setProperty('--mouse-x', `${x}%`);
      e.currentTarget.style.setProperty('--mouse-y', `${y}%`);
    }
      };



  // Initialize sizeOptions from campaign.sizes for companies not explicitly handled
  useEffect(() => {
    const explicitlyHandledCompanyIds = [
      process.env.REACT_APP_REGENT_COMPANY_ID, // Regent
      "65cd150fdc2cf13513530120", // Encore
      "65d52364dc2cf135135301fd", // Live Nation
      "67981cfbdca127a271575000", // Wiz/Concentrix
      "66639212d7476d285f2b1cfe", // Impiricus
      "67294a3bdca127a271571be4", // ModernHealth
      "6792c702dca127a271574e4d", // Concentrix (different ID)
      "67f6b6badca127a27157640b", // EdwardsLS
      "68140062cee86b5fec95476e", // Gusto
      "6840f57ecee86b5fec9562c6", // Cyera
      "6530617ad257c395c2f9a961", // 1011
      "66bad2e5a6ecf67d94f0f31f", // WilmingtonTrust
    ];
    
    const isExplicitlyHandled = explicitlyHandledCompanyIds.includes(campaign.companyId);
    
    if (!isExplicitlyHandled && campaign.sizes && (!sizeOptions || sizeOptions.length === 0)) {
      const sizes = (campaign.sizes || "")
        .split(",")
        .map((size) => size.trim())
        .filter((size) => size.length);
      
      if (sizes.length > 0) {
        safeUpdateSelectionState({
          sizeOptions: [sizes],
        });
      }
    }
  }, [campaign.sizes, campaign.companyId, sizeOptions]);


  // useEffect(() => {
  //   console.log("campaign", campaign);
  // }, [campaign]);

  const giftDashboardBaseClass = isRegent ? "gift-dashboard-regent" : "gift-dashboard";
  const giftDashboardClassName = [
    giftDashboardBaseClass,
    isEncore ? "encore-font" : "default-font",
    !isRegent && isPhilo ? "gift-dashboard--philo-mobile" : null,
    isPlenty ? "gift-dashboard--plenty" : null,
    isWorldCruise2027 ? "gift-dashboard-regent--compact" : null,
  ].filter(Boolean).join(" ");

  return (
    <div
      className={giftDashboardClassName}
      style={{
        ...(isNewGusto ? { background: `url('${process.env.REACT_APP_API_URL}/${campaign.loginImage.path}')`, backgroundRepeat: "no-repeat", /* This stops the image from repeating */
          backgroundSize: "cover", /* Optional: makes it cover the entire element */
          backgroundPosition: "center" } : {}),
        ...(campaign.color ? { backgroundColor: campaign.color } : {}),
        ...(isWiz ? { padding: "0" } : {})
      }}
    >
      {!isPlenty && <Back back={prev} />}

      {/* Product description + size chart popup (World Cruise 2027) */}
      <Modal
        show={!!infoProduct}
        onHide={() => setInfoProduct(null)}
        centered
        scrollable
        size="lg"
        className="product-info-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{infoProduct?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body dangerouslySetInnerHTML={{ __html: infoProduct?.descriptionHtml || "" }} />
      </Modal>

      {/* Welcome Modal for Wiz */}
      <Modal
        show={showWelcomeModal}
        onHide={() => setShowWelcomeModal(false)}
        centered
        className="wiz-welcome-modal"
      >
        <Modal.Body style={{
          backgroundColor: "#f8e8ff",
          borderRadius: "20px",
          padding: "30px",
          textAlign: "center"
        }}>
          <img
            src={WizHooray}
            alt="Wiz Hooray"
            style={{
              maxWidth: "300px",
              marginBottom: "20px"
            }}
          />
          {/* <h2 style={{ 
            color: "#1e50e7",
            fontSize: "24px",
            marginBottom: "20px"
          }}>
            Welcome to Your Gift Selection!
          </h2> */}
          <p style={{
            color: "#1e50e7",
            fontSize: "16px",
            lineHeight: "1.5",
            marginBottom: "30px"
          }}>
            Time to send some love! {<br></br>}
            Select which box you'd like to send to an important person in your life. {<><br></br><br></br></>}
            We'll handle the rest to make the magic happen!
          </p>
          <WizButton onClick={() => setShowWelcomeModal(false)}>
            Get Started
          </WizButton>
        </Modal.Body>
      </Modal>

      <div style={isWiz ? { position: "relative", backgroundImage: `url(${WizBG})`, backgroundSize: "cover", backgroundPosition: "center", padding: "0 36px" } : isImpiricus ? { backgroundColor: campaign.bgColor, color: "white" } : campaign.bgColor ? { backgroundColor: campaign.bgColor } : null} className="gift-select">
        {isRegent ? (
          <div className={isWiz ? "logo wiz-logo" : "logo"}>
            <img className="logo-mobile" style={{ maxWidth: "60px" }} src={LogoNew} alt="logo" />
          </div>
        ) : isWiz ? (
          <div className={isWiz ? "logo wiz-logo" : "logo"}>
            <img className="logo-desktop" style={{ height: "auto", maxWidth: "400px", width: "100%" }} src={WizBoxfoxLogo} alt="logo" />
            <img className="logo-mobile" style={{ height: "auto", maxWidth: "200px", width: "100%" }} src={WizBoxfoxLogo} alt="logo" />
          </div>
        ) : isImpiricus ? (
          <div className="logo">
            <img className="logo-desktop" src={`${process.env.REACT_APP_API_URL}/${campaign.logo.path}`} alt="logo" />
            <img className="logo-mobile" src={`${process.env.REACT_APP_API_URL}/${campaign.logo.path}`} alt="logo" />
            <h2
              style={{
                color: "white",
                fontFamily: "monospace",
                letterSpacing: "0.1em",
                margin: "24px 0",
              }}
            >
              RFP SURVIVAL KIT
            </h2>
          </div>
        ) : isCyera ? (
          <div className="logo" style={{ display: "flex", justifyContent: "flex-start" }}>
            <img className="logo-desktop" src={`${process.env.REACT_APP_API_URL}/${campaign.logo.path}`} alt="logo" />
            <img className="logo-mobile" src={`${process.env.REACT_APP_API_URL}/${campaign.logo.path}`} alt="logo" />
          </div>
        ) : isNewGusto ? (
          <div className="logo">
            <img className="logo-desktop" src={`${process.env.REACT_APP_API_URL}/${campaign.logo.path}`} alt="logo" />
            <img className="logo-mobile" src={`${process.env.REACT_APP_API_URL}/${campaign.logo.path}`} alt="logo" />
          </div>
        ) : isPhilo ? (
          <div className="logo">
            <img className="logo-desktop" src={Logo} alt="logo" />
            <img className="logo-mobile" src={PhiloDarkLogo} alt="logo" />
          </div>
        ) : (
          <div className="logo">
            <img className="logo-desktop" src={Logo} alt="logo" />
            <img className="logo-mobile" src={LogoMobile} alt="logo" />
          </div>
        )}

        <p style={isWiz ? { display: "none" } : null} className="gift-desc">
          {isRegent
            ? (isWorldCruise2027
                ? "Please select a polo, a jacket or vest, and a hat or belt bag for each guest. These will be waiting for you onboard."
                : isWorldCruiseDisplay
                ? "Please select your polo sizing and either a jacket or a vest. These will be waiting for you onboard."
                : "Please select either a jacket or a vest for each guest. These will be waiting for you onboard.")
            : isNewGusto ? "It's a surprise but we'll make sure to 'capture' everything and wrap it all nicely in a box." : isPhilo ? "" : isPlenty ? "" : "Select your gift below"}
        </p>
        <p className="gift-desc-text">{campaign.productText} {isCyeraSecretSanta2 ? <p>Read your match’s “About Me,” pick the gift theme that feels right… and let the holiday magic do the rest!</p> : isCyera ? <p>Choose one family game to complete the package - pick the fun that fits your crew best!
          </p> : null}</p>
        {isRegent && isSelectionOpen && skuOptions && skuOptions[currentGenderIndex] && (
          <h3 style={{ marginTop: "10px" }}>{isWorldCruise2027
            ? `Guest ${currentGenderIndex + 1} - ${worldCruiseOptionLabels[currentOptionIndex]}`
            : `Select for Guest ${currentGenderIndex + 1}${skuOptions[currentGenderIndex].length === 1 ? '' : ` - Option ${currentOptionIndex + 1}`
            }`}</h3>
        )}
        <div style={isWiz ? { paddingTop: windowHeight < 721 && windowHeight > 669 ? "32px" : windowHeight < 669 ? "2px" : "" } : isImpiricus || isCyera ? { paddingTop: "0px" } : null} className="gift-group">
          <p style={isWiz && !isPlenty ? { display: "block", color: "#1e50e7", marginBottom: "18px", width: "100%", textAlign: "left" } : { display: "none" }} className="gift-desc">
            Select your gift below
          </p>
          {isRegent ? (
            <>
              {isSelectionOpen ? (
                <div>
                  {/* Ask gender first (World Cruise 2027 shows both genders instead) */}
                  {!isWorldCruise2027 && (
                  <div style={{ maxWidth: 520, margin: "0 auto 16px" }}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        {skuOptions?.length === 1 && skuOptions[0]?.length === 1
                          ? "Select Gender"
                          : `Select Gender for Guest ${currentGenderIndex + 1}`}
                        :
                      </Form.Label>
                      <Form.Control
                        as="select"
                        value={selectedGenders[`${currentGenderIndex}-${currentOptionIndex}`] || ""}
                        onChange={(e) => handleGenderChange(currentGenderIndex, currentOptionIndex, e.target.value)}
                      >
                        <option value="">Choose a gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </Form.Control>
                    </Form.Group>
                  </div>
                  )}
                  <div className="regent-product-row" style={{ display: "flex", flexDirection: "row" }}>
                    {filteredProducts
                      .filter((item) => {
                        if (isWorldCruise2027) {
                          return matchesWorldCruise2027Option(item, currentOptionIndex);
                        }
                        // If we have a gender selected, show all products for that gender
                        const selectedGender = selectedGenders[`${currentGenderIndex}-${currentOptionIndex}`];
                        if (selectedGender) {
                          const handle = item.handle.toLowerCase();
                          const normalizedCampaignName = campaign.name.toLowerCase().replace(/[-\s]/g, '');
                          const isWorldCruise = normalizedCampaignName.includes('worldcruise2026') || normalizedCampaignName.includes('worldcruise2027');
                          const isAsiaCampaign = normalizedCampaignName.includes('grandasia') || normalizedCampaignName.includes('grandasianexploration') || normalizedCampaignName.includes('indianodyssey');
                          if (selectedGender === 'Female') {
                            if (isWorldCruise) {
                              // option 0: polo women; option 1: vest/jacket women
                              const isOuterwearOption = currentOptionIndex === 1;
                              return isOuterwearOption
                                ? (handle.includes('vest-womens') || handle.includes('jacket-womens'))
                                : handle.includes('polo-womens');
                            }
                            // Include 'women' (singular) to support campaigns like Grand Asia and Indian Odyssey
                            return handle.includes('womens') || handle.includes('women') || handle.includes('zephyr');
                          } else {
                            if (isWorldCruise) {
                              const isOuterwearOption = currentOptionIndex === 1;
                              return isOuterwearOption
                                ? (handle.includes('vest-mens') || handle.includes('jacket-mens'))
                                : (handle.includes('polo') && !handle.includes('polo-womens'));
                            }
                            return handle.includes('mens') || handle.includes('eddie-bauer');
                          }
                        }

                        // If no gender selected, do not show any products
                        return false;
                      })
                      .map((item, index) => (
                        <div
                          key={index}
                          className={`gift ${selections[currentGenderIndex][currentOptionIndex]
                              ?.handle === item.handle
                              ? "active"
                              : "deactive"
                            }`}
                        >
                          <Button
                            onClick={() => {
                              if (isRegent) {
                                const newSelections = [...selections];
                                newSelections[currentGenderIndex][
                                  currentOptionIndex
                                ] = item;

                                if (isAccessoryOption(currentOptionIndex)) {
                                  // No size or gender to pick for the hat / belt bag; fill them so validation passes.
                                  safeUpdateSelectionState({
                                    selections: newSelections,
                                    selectedSizes: {
                                      ...selectedSizes,
                                      [calculateSizeIndex(currentGenderIndex, currentOptionIndex)]: "One Size",
                                    },
                                  });
                                  setSelectedGenders(prev => ({
                                    ...prev,
                                    [`${currentGenderIndex}-${currentOptionIndex}`]: "N/A",
                                  }));
                                  return;
                                }

                                if (isWorldCruise2027) {
                                  // Gender comes from the picked product (men's or women's) since there's no picker.
                                  setSelectedGenders(prev => ({
                                    ...prev,
                                    [`${currentGenderIndex}-${currentOptionIndex}`]: getWorldCruise2027Kind(item).gender,
                                  }));
                                }

                                safeUpdateSelectionState({
                                  selections: newSelections,
                                });
                              } else {
                                setProduct(item);
                              }
                            }}
                          >
                            {item.images && item.images.length > 0 && (
                              <img src={item.images[0].src} alt="product" style={isCyeraSecretSanta2 ? { filter: 'blur(10px)' } : null} />
                            )}
                          </Button>
                          <p style={isWiz ? { color: "#1e50e7", fontSize: "16px" } : isImpiricus ? { color: "white !important" } : null} className="product-title">{item.title}</p>
                          {isWorldCruise2027 && (
                            <button
                              type="button"
                              className="product-info-link"
                              aria-label={`Product description and size chart for ${item.title}`}
                              onClick={() => setInfoProduct(item)}
                            >
                              PRODUCT DESCRIPTION + SIZE CHART
                            </button>
                          )}
                        </div>
                      ))}
                  </div>
                  {/* same size for both tags inside flex row */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "10px",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {sizeOptions &&
                      sizeOptions.length > 0 &&
                      !isAccessoryOption(currentOptionIndex) &&
                      selections?.[currentGenderIndex]?.[currentOptionIndex] && (
                        <div style={{ flex: 1 }}>
                          <Form.Group
                            style={{ textAlign: "left" }}
                            className="mb-3"
                          >
                            <Form.Label>
                              {skuOptions?.length === 1 && skuOptions[0]?.length === 1
                                ? "Select Size"
                                : `Select Size for Guest ${currentGenderIndex + 1}`}:
                            </Form.Label>
                            <div className="d-flex gap-2">
                              <Form.Control
                                as="select"
                                value={
                                  selectedSizes?.[
                                  calculateSizeIndex(currentGenderIndex, currentOptionIndex)
                                  ] || ""
                                }
                                onChange={(e) =>
                                  handleSizeChange(
                                    calculateSizeIndex(currentGenderIndex, currentOptionIndex),
                                    e.target.value
                                  )
                                }
                                style={{ flex: 1 }}
                              >
                                <option value="">Choose a size</option>
                                {sizeOptions?.[
                                  calculateSizeIndex(currentGenderIndex, currentOptionIndex)
                                ]?.map((size, idx) => (
                                  <option key={idx} value={size}>
                                    {size}
                                  </option>
                                )) || null}
                              </Form.Control>
                            </div>
                          </Form.Group>
                        </div>
                      )}
                    <Button
                      style={{
                        flex: 1,
                        display: (
                          // Hide if it's the last gender and last option
                          currentGenderIndex === skuOptions.length - 1 &&
                          currentOptionIndex === skuOptions[currentGenderIndex].length - 1
                        ) ? 'none' : 'block'
                      }}
                      variant="secondary"
                      disabled={
                        // if current selection is empty
                        !selections?.[currentGenderIndex]?.[currentOptionIndex] ||
                        !selectedSizes?.[
                        calculateSizeIndex(currentGenderIndex, currentOptionIndex)
                        ]
                      }
                      onClick={() => {
                        const currentGender = selectedGenders[`${currentGenderIndex}-${currentOptionIndex}`];

                        if (
                          skuOptions?.[currentGenderIndex] &&
                          currentOptionIndex <
                          skuOptions[currentGenderIndex].length - 1
                        ) {
                          // Moving to next option within same guest; clear any preselected gender for the next option
                          const nextOptionKey = `${currentGenderIndex}-${currentOptionIndex + 1}`;
                          setSelectedGenders(prev => {
                            const newState = { ...prev };
                            delete newState[nextOptionKey];
                            return newState;
                          });

                          // Update filtered products for the next selection
                          const normalizedCampaignName = campaign.name.toLowerCase().replace(/[-\s]/g, '');
                          const isArcticCampaign = normalizedCampaignName.includes('grandarctic');
                          const isWorldCruise = normalizedCampaignName.includes('worldcruise2026') || normalizedCampaignName.includes('worldcruise2027');
                          const isCulturalCampaign = normalizedCampaignName.includes('grandculturalquest');
                          const isContinentalCampaign = normalizedCampaignName.includes('grandcontinental');
                          const isAsiaCampaign = normalizedCampaignName.includes('grandasia') || normalizedCampaignName.includes('grandasianexploration') || normalizedCampaignName.includes('indianodyssey');
                          // Grand Asia 2026 reuses the Grand Arctic products (Indian Odyssey / Grand Asian Exploration keep their own).
                          const isGrandAsia2026 = normalizedCampaignName.includes('grandasia2026');

                          const arcticProducts = {
                            male: {
                              vest: 'eddie-bauer-mens-fleece-vest-grand-arctic',
                              jacket: 'mens-sport-tek-full-zip-wind-jacket-grand-arctic'
                            },
                            female: {
                              vest: 'port-authority-womens-core-soft-shell-vest-grand-arctic',
                              jacket: 'port-authority-zephyr-full-zip-jacket-grand-arctic'
                            }
                          };

                          const culturalProducts = {
                            male: {
                              vest: 'eddie-bauer-mens-fleece-vest-grand-quest',
                              jacket: 'mens-sport-tek-full-zip-wind-jacket-grand-quest'
                            },
                            female: {
                              vest: 'port-authority-womens-core-soft-shell-vest-grand-quest',
                              jacket: 'port-authority-zephyr-full-zip-jacket-grand-quest'
                            }
                          };

                          const continentalProducts = {
                            male: {
                              vest: 'eddie-bauer-mens-fleece-vest-grand-continental',
                              jacket: 'mens-sport-tek-full-zip-wind-jacket-grand-continental'
                            },
                            female: {
                              vest: 'port-authority-womens-core-soft-shell-vest-grand-continental',
                              jacket: 'port-authority-zephyr-full-zip-jacket-grand-continental'
                            }
                          };

                          // Asia products are used for both Grand Asia and Indian Odyssey campaigns
                          const asiaProducts = {
                            male: {
                              vest: 'grand-asia-vest-mens',
                              jacket: 'grand-asia-insulated-jacket-mens'
                            },
                            female: {
                              vest: 'grand-asia-vest-women',
                              jacket: 'grand-asia-insulated-jacket-womens'
                            }
                          };

                          const worldCruiseProducts = {
                            male: {
                              polo: 'world-cruise-travis-mathew-polo',
                              vest: 'world-cruise-eddie-bauer-vest-mens',
                              jacket: 'world-cruise-insulated-jacket-mens'
                            },
                            female: {
                              polo: 'world-cruise-travis-mathew-polo-womens',
                              vest: 'world-cruise-eddie-bauer-vest-womens',
                              jacket: 'world-cruise-insulated-jacket-womens'
                            }
                          };

                          const targetProducts = isWorldCruise
                            ? worldCruiseProducts
                            : (isArcticCampaign || isGrandAsia2026)
                              ? arcticProducts
                              : isCulturalCampaign
                                ? culturalProducts
                                : isContinentalCampaign
                                  ? continentalProducts
                                  : asiaProducts;

                          let relevantProducts;
                          if (isAccessoryOption(currentOptionIndex + 1)) {
                            relevantProducts = [];
                          } else if (isWorldCruise) {
                            const goingToOptionIndex = currentOptionIndex + 1;
                            const isOuterwearOption = goingToOptionIndex === 1; // option 1 is outerwear
                            // When gender is not set yet for the next option, show both genders
                            relevantProducts = isOuterwearOption
                              ? [
                                  targetProducts.male.vest,
                                  targetProducts.male.jacket,
                                  targetProducts.female.vest,
                                  targetProducts.female.jacket,
                                ]
                              : [
                                  targetProducts.male.polo,
                                  targetProducts.female.polo,
                                ];
                          } else {
                            relevantProducts = [
                              targetProducts.male.vest,
                              targetProducts.male.jacket,
                              targetProducts.female.vest,
                              targetProducts.female.jacket
                            ];
                          }

                          const nextList = products.filter(product => {
                            if (!product) return false;
                            // Hide sold out items
                            if (product?.availableForSale === false) {
                              return false;
                            }
                            const handle = product.handle.toLowerCase();
                            if (isAccessoryOption(currentOptionIndex + 1)) return isWorldCruiseAccessory(product);
                            return relevantProducts.some(sku => handle.includes(sku.toLowerCase()));
                          });

                          setFilteredProducts(nextList);

                          safeUpdateSelectionState({
                            currentOptionIndex: currentOptionIndex + 1,
                            isSelectionOpen: true
                          });
                        } else if (skuOptions?.length > currentGenderIndex + 1) {
                          // Moving to next guest, clear any preselected gender
                          const nextGenderKey = `${currentGenderIndex + 1}-0`;
                          setSelectedGenders(prev => {
                            const newState = { ...prev };
                            delete newState[nextGenderKey];
                            return newState;
                          });

                          // Show all relevant items for the next guest initially
                          const normalizedCampaignName = campaign.name.toLowerCase().replace(/[-\s]/g, '');
                          const isArcticCampaign = normalizedCampaignName.includes('grandarctic');
                          const isWorldCruise = normalizedCampaignName.includes('worldcruise2026') || normalizedCampaignName.includes('worldcruise2027');
                          const isCulturalCampaign = normalizedCampaignName.includes('grandculturalquest');
                          const isContinentalCampaign = normalizedCampaignName.includes('grandcontinental');
                          // Grand Asia 2026 reuses the Grand Arctic products (Indian Odyssey / Grand Asian Exploration keep their own).
                          const isGrandAsia2026 = normalizedCampaignName.includes('grandasia2026');

                          const arcticProducts = {
                            male: {
                              vest: 'eddie-bauer-mens-fleece-vest-grand-arctic',
                              jacket: 'mens-sport-tek-full-zip-wind-jacket-grand-arctic'
                            },
                            female: {
                              vest: 'port-authority-womens-core-soft-shell-vest-grand-arctic',
                              jacket: 'port-authority-zephyr-full-zip-jacket-grand-arctic'
                            }
                          };

                          const culturalProducts = {
                            male: {
                              vest: 'eddie-bauer-mens-fleece-vest-grand-quest',
                              jacket: 'mens-sport-tek-full-zip-wind-jacket-grand-quest'
                            },
                            female: {
                              vest: 'port-authority-womens-core-soft-shell-vest-grand-quest',
                              jacket: 'port-authority-zephyr-full-zip-jacket-grand-quest'
                            }
                          };

                          const continentalProducts = {
                            male: {
                              vest: 'eddie-bauer-mens-fleece-vest-grand-continental',
                              jacket: 'mens-sport-tek-full-zip-wind-jacket-grand-continental'
                            },
                            female: {
                              vest: 'port-authority-womens-core-soft-shell-vest-grand-continental',
                              jacket: 'port-authority-zephyr-full-zip-jacket-grand-continental'
                            }
                          };

                          const worldCruiseProducts = {
                            male: {
                              polo: 'world-cruise-travis-mathew-polo',
                              vest: 'world-cruise-eddie-bauer-vest-mens',
                              jacket: 'world-cruise-insulated-jacket-mens'
                            },
                            female: {
                              polo: 'world-cruise-travis-mathew-polo-womens',
                              vest: 'world-cruise-eddie-bauer-vest-womens',
                              jacket: 'world-cruise-insulated-jacket-womens'
                            }
                          };

                          const targetProducts = isWorldCruise
                            ? worldCruiseProducts
                            : (isArcticCampaign || isGrandAsia2026)
                              ? arcticProducts
                              : isCulturalCampaign
                                ? culturalProducts
                                : continentalProducts;

                          const allPossibleSkus = isWorldCruise
                            ? [
                                // Start with polo selection for next guest, both genders
                                targetProducts.male.polo,
                                targetProducts.female.polo,
                              ]
                            : [
                                targetProducts.male.vest,
                                targetProducts.male.jacket,
                                targetProducts.female.vest,
                                targetProducts.female.jacket
                              ];

                          const allProducts = products.filter(product => {
                            if (!product) return false;
                            // Hide sold out items
                            if (product?.availableForSale === false) {
                              return false;
                            }
                            const handle = product.handle.toLowerCase();
                            return allPossibleSkus.some(sku => handle.includes(sku.toLowerCase()));
                          });

                          setFilteredProducts(allProducts);

                          // Don't set a default gender for the next guest
                          const nextGuestFirstOptionKey = `${currentGenderIndex + 1}-0`;
                          setSelectedGenders(prev => {
                            const newState = { ...prev };
                            delete newState[nextGuestFirstOptionKey]; // Remove any existing gender selection
                            return newState;
                          });

                          safeUpdateSelectionState({
                            currentGenderIndex: currentGenderIndex + 1,
                            currentOptionIndex: 0,
                            isSelectionOpen: true
                          });
                        } else {
                          safeUpdateSelectionState({ isSelectionOpen: false });
                        }
                      }}
                    >
                      Next
                    </Button>
                    {isRegent && canProceed && allItemsSelected && allSizesSelected && allGendersSelected && (
                      <Button
                        variant="secondary"
                        className="btn-next"
                        style={{ flex: "1 1 0%" }}
                        onClick={() => next()}
                        disabled={!canProceed}
                      >
                        Continue
                      </Button>
                    )}

                    {/* get the size for the current option here is how I get the size index  selections.flat().map index */}
                  </div>
                </div>
              ) : (
                <div className="closed-selection-container">
                  {selections.map((gender, genderIndex) => (
                    <div key={genderIndex} className="gender-selection">
                      <h4>{genderOptions[genderIndex]}</h4>
                      <div className="options-container">
                        {gender.map((product, optionIndex) => {
                          const sizeIndex = calculateSizeIndex(genderIndex, optionIndex);
                          return (
                            <div
                              key={optionIndex}
                              className="selected-product"
                              onClick={() =>
                                openSelection(genderIndex, optionIndex)
                              }
                            >
                              <p>
                                {product
                                  ? `${product.title} - ${selectedSizes?.[sizeIndex] || 'No size selected'}`
                                  : `Select Option ${optionIndex + 1}`}
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          ) : isLiveNationCampaign2024 ? (
            finalSortedProducts.length > 0 &&
            finalSortedProducts.map(
              (item, index) =>
                item && (
                  <div
                    key={index}
                    className={`gift ${product && product?.handle === item.handle
                        ? "active"
                        : "deactive"
                      }`}
                  >
                    <Button
                      onClick={() => {
                        setProduct(item);
                      }}
                    >
                      {item.images && item.images.length > 0 && (
                        <img src={item.images[0].src} alt="product" style={isCyeraSecretSanta2 ? { filter: 'blur(10px)' } : null} />
                      )}
                    </Button>
                    <p style={isWiz ? { color: "#1e50e7" } : isImpiricus ? { color: "white !important" } : null} className="product-title">{item.title}</p>
                  </div>
                )
            )
          ) : filteredProducts.length > 0 ? (
            filteredProducts.map(
              (item, index) =>
                item && (
                  <div
                    key={index}
                    className={`${isWiz ? "wiz-gift" : "gift"} ${product && product?.handle === item.handle
                        ? "active"
                        : "deactive"
                      }`}
                  >
                    <Button
                      onClick={() => {
                        setProduct(item);
                        // If it's Wiz and mobile, automatically proceed to next step
                        if (isWiz && isMobile) {
                          next();
                        }
                      }}
                    >
                      {item.handle === "decline-gift" ? (
                        <div style={{ padding: "20px", textAlign: "center" }}>
                          Decline Gift
                        </div>
                      ) : (
                        item.images && item.images.length > 0 && (
                          <img src={item.images[0].src} alt="product" style={isCyeraSecretSanta2 ? { filter: 'blur(10px)' } : null} />
                        )
                      )}
                    </Button>
                    {item.handle !== "decline-gift" && (
                      <p style={isWiz ? { color: "#1e50e7" } : isImpiricus ? { color: "white" } : null} className="product-title">{item.title}</p>
                    )}
                  </div>
                )
            )
          ) : null}
        </div>

        {!isRegent && (
          isWiz ? (
            <WizButton
              // variant="secondary"
              className="btn-next mb-4"
              onClick={() => next()}
              disabled={!canProceed}
            >
              Next
            </WizButton>
          ) : (
            <Button
              variant="secondary"
              className="btn-next mb-4"
              style={isPhilo ? { width: "200px" } : null}
              onClick={() => next()}
              disabled={!canProceed}
            >
              Next
            </Button>
          )
        )}
      </div>
      {isWiz ? (
        <div className={`gift-images wiz-gift-images`} style={{paddingTop: windowHeight < 721 && windowHeight > 669 ? "150px" : windowHeight < 669 ? "120px" : "200px"}}>
          <div style={{ display: "grid", flexDirection: "column", alignItems: "center" }}>
            {Object.keys(product).length > 0 && product.images
              ? product.images.map((image, index) => (
                <div 
                  style={isWiz ? { padding: "5px 30px" } : null} 
                  key={index}
                  onMouseMove={handleMouseMove}
                >
                  <img src={image.src} alt="Product" style={isCyeraSecretSanta2 ? { filter: 'blur(10px)' } : null} />
                </div>
              ))
              : null}
          </div>
        </div>
      ) : (
        <div className={`gift-images ${isWiz ? "wiz-gift-images" : ""} ${isNewGusto ? "new-gusto-wiggle" : ""}`}>
          {isRegent && selections.length > 0
            ? selections.flat().map((product, index) =>
              product && product.images && product.images.length > 0 ? (
                <div key={index}>
                  <img src={product.images[0].src} alt="Product" style={isCyeraSecretSanta2 ? { filter: 'blur(10px)' } : null} />
                </div>
              ) : null
            )
            : Object.keys(product).length > 0 && product.images
              ? product.images.map((image, index) => {
                const imgStyle = {};
                if (isNewGusto) {
                  imgStyle.mixBlendMode = "multiply";
                }
                if (isCyeraSecretSanta2) {
                  imgStyle.filter = 'blur(10px)';
                }
                return (
                  <div style={isWiz ? { padding: "10px 40px" } : null} key={index}>
                    <img style={Object.keys(imgStyle).length > 0 ? imgStyle : null} src={image.src} alt="Product" />
                  </div>
                );
              })
              : null}
        </div>
      )}
      <div
        style={{
          backgroundColor: isImpiricus ? "white" : isNewGusto ? "" : campaign.bgColor || null,
          color: campaign.textColor || null,
        }}
        className={`${isWiz ? "gift-details-wiz" : "gift-details"}`}
      >
        <div style={isWiz ? { display: "flex", flexDirection: "column", alignItems: "start", justifyContent: "start", paddingTop: windowHeight < 721 && windowHeight > 669  ? "85px" : windowHeight < 669 ? "55px" : "135px" } : null}>
          {isRegent &&
            sizeOptions &&
            sizeOptions.length > 0 &&
            allItemsSelected &&
            sizeOptions.flat().length > 0 && (
              <p
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                }}
              >
                {Object.keys(selectedSizes).length} / {sizeOptions.length}
              </p>
            )}
          {isRegent ? (
            selections.flat().map(
              (product, flatIndex) => {
                if (!product) return null;

                // Calculate the gender index and option index from the flat index
                let calculatedGenderIndex = 0;
                let calculatedOptionIndex = flatIndex;
                let totalOptions = 0;

                // Find the correct gender and option index
                for (let i = 0; i < skuOptions?.length || 0; i++) {
                  const currentOptions = skuOptions[i]?.length || 0;
                  if (totalOptions + currentOptions > flatIndex) {
                    calculatedGenderIndex = i;
                    calculatedOptionIndex = flatIndex - totalOptions;
                    break;
                  }
                  totalOptions += currentOptions;
                }

                const sizeIndex = calculateSizeIndex(calculatedGenderIndex, calculatedOptionIndex);

                // console.log('Details section - Product:', {
                //   title: product?.title,
                //   flatIndex,
                //   calculatedGenderIndex,
                //   calculatedOptionIndex,
                //   sizeIndex,
                //   hasSize: sizeOptions?.[sizeIndex]?.length > 0,
                //   selectedSize: selectedSizes?.[sizeIndex]
                // });

                return (
                  <div key={flatIndex} className="product-details-item">
                    <h1>{product.title}</h1>
                    {product.descriptionHtml && (
                      <>
                        <h4>Description</h4>
                        <div
                          className="product-info"
                          dangerouslySetInnerHTML={{
                            __html: product.descriptionHtml,
                          }}
                        />
                      </>
                    )}
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Select Size and Gender for Guest {calculatedGenderIndex + 1}:
                      </Form.Label>
                      <div className="d-flex gap-2">
                        <Form.Control
                          as="select"
                          className={`size-dropdown-${sizeIndex}`}
                          value={selectedSizes?.[sizeIndex] || ""}
                          onChange={(e) => {
                            // console.log('Changing size in details section - Index:', sizeIndex);
                            handleSizeChange(sizeIndex, e.target.value);
                          }}
                          style={{ flex: 1 }}
                        >
                          <option value="">Choose a size</option>
                          {["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"].map((size, idx) => (
                            <option key={idx} value={size}>
                              {size}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control
                          as="select"
                          style={{ flex: 1 }}
                          value={selectedGenders[`${calculatedGenderIndex}-${calculatedOptionIndex}`] || ""}
                          onChange={(e) => handleGenderChange(calculatedGenderIndex, calculatedOptionIndex, e.target.value)}
                        >
                          <option value="">Choose a gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </Form.Control>
                      </div>
                    </Form.Group>
                    <hr className="my-4" />
                  </div>
                );
              }
            )
          ) : (
            <>
              {product && (
                <div style={isWiz ? { color: "#0254EC" } : null}>
                  {isPlenty && campaign.logo && (
                    <img
                      src={`${process.env.REACT_APP_API_URL}/${campaign.logo.path}`}
                      alt="Plenty logo"
                      className="plenty-logo"
                    />
                  )}
                  {isNewGusto ? null : <h1>{product.title}</h1>}
                  {desc ? (
                    <>
                      <h4>Description</h4>
                      <div
                        className="product-info"
                        style={isWiz ? { fontSize: "16px", lineHeight: "22px" } : null}
                        dangerouslySetInnerHTML={{
                          __html: desc || product.descriptionHtml,
                        }}
                      />
                    </>
                  ) :  product.descriptionHtml && (
                    <>
                      <h4>Description</h4>
                      <div
                        className="product-info"
                        style={isWiz ? { fontSize: "16px", lineHeight: "22px" } : null}
                        dangerouslySetInnerHTML={{
                          __html: product.descriptionHtml,
                        }}
                      />
                    </>
                  )}
                  {sizeOptions &&
                    sizeOptions[0] &&
                    sizeOptions[0].length > 0 && (
                      <Form.Group className="mb-3">
                        <Form.Label>Select Size:</Form.Label>
                        <Form.Control
                          as="select"
                          value={selectedSizes[0] || ""}
                          onChange={(e) => handleSizeChange(0, e.target.value)}
                        >
                          <option value="">Choose a size</option>
                          {sizeOptions[0].map((size, idx) => (
                            <option key={idx} value={size}>
                              {size}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    )}
                  {isCyera && !isCyeraSecretSanta2 && (
                    <Form.Group className="mb-3">
                      <Form.Label>Game Choice:</Form.Label>
                      <Form.Control
                        as="select"
                        value={gameChoice}
                        onChange={(e) => {
                          const selectedGame = e.target.value;
                          setGameChoice(selectedGame);
                          // Update both the game choice and form size
                          setForm(prevForm => ({
                            ...prevForm,
                            size: selectedGame
                          }));
                          // Directly update the size for the product
                          safeUpdateSelectionState({
                            selectedSizes: { ...selectedSizes, 0: selectedGame }
                          });
                        }}
                        required
                      >
                        <option value="">Choose a game</option>
                        <option value="TableTopics Family Edition">TableTopics Family Edition</option>
                        <option value="Games Room Family Game Night">Games Room Family Game Night</option>
                        <option value="Spark Family Fun">Spark Family Fun</option>
                      </Form.Control>
                    </Form.Group>
                  )}
                </div>
              )}
            </>
          )}
          {includes && (
            <div style={isWiz ? { color: "#0254EC" } : null}>
              <h4>Includes</h4>
              <div
                className="product-info"
                dangerouslySetInnerHTML={{ __html: includes }}
              />
            </div>
          )}
          {details && (
            <div style={isWiz ? { color: "#0254EC" } : null}>
              <h4>the details</h4>
              <div
                className="product-info"
                dangerouslySetInnerHTML={{ __html: details }}
              />
            </div>
          )}
          {campaign.enableImage && (
            <Form.Group className="mb-3 mt-4">
              <Form.Label>UPLOAD YOUR IMAGE HERE:</Form.Label>
              <Form.Control type="file" onChange={changeHandler} />
            </Form.Group>
          )}
          {campaign.enableNote && (
            <Form.Group>
              <Form.Label style={{ marginBottom: "0px" }}>
                ADD A CUSTOM NOTE:
              </Form.Label>
              {/* Red error */}
              {showRequiredField && (
                <Form.Text className="text-sm">
                  <p
                    style={{
                      color: "rgba(255, 0, 0, 0.75)",
                      marginBottom: "2px",
                    }}
                  >
                    * required
                  </p>
                </Form.Text>
              )}
              <Form.Control
                value={note}
                required
                onChange={(e) => setNote(e.target.value)}
                as="textarea"
                rows="4"
                maxLength={255}
              />
              <Form.Label className="text-sm">255 Characters</Form.Label>
            </Form.Group>
          )}
        </div>

        {isWiz ? (
          product && product.handle && (
            <b style={{width: "100%", display: "flex", alignItems: "center", justifyContent: "center"}}>
          <WizButton
          style={{maxWidth: "220px"}}
            onClick={() => {
              if ((note === "" || note === " ") && isLiveNation) {
                setShowRequiredField(true);
              } else if (!canCheckout) {
                if (!allItemsSelected) {
                  alert("Please select all items before proceeding to checkout.");
                } else if (isRegent && !allSizesSelected) {
                  alert("Please select all sizes before proceeding to checkout.");
                } else if (isCyera && !gameChoice) {
                  alert("Please select a game before proceeding to checkout.");
                }
              } else {
                if (!isRegent) {
                  if (!product || !product.handle) {
                    alert("Please select a product before proceeding to checkout.");
                    return;
                  }
                }
                setShowRequiredField(false);
                gotoCheckout();
              }
            }}
          >Confirm</WizButton></b>)
        ) : (
          <Button
            onClick={() => {
              if ((note === "" || note === " ") && isLiveNation) {
                setShowRequiredField(true);
              } else if (!canCheckout) {
                if (!allItemsSelected) {
                  alert("Please select all items before proceeding to checkout.");
                } else if (isRegent && !allSizesSelected) {
                  alert("Please select all sizes before proceeding to checkout.");
                } else if (isCyera && !gameChoice) {
                  alert("Please select a game before proceeding to checkout.");
                }
              } else {
                if (!isRegent) {
                  if ((!product || !product.handle) && !isPhilo) {
                    alert("Please select a product before proceeding to checkout.");
                    return;
                  }
                }
                setShowRequiredField(false);
                gotoCheckout();
              }
            }}
            variant="secondary"
            className="btn-checkout"
            disabled={!canCheckout}
            style={{
              backgroundColor: campaign.buttonColor || null,
              color: campaign.buttonTextColor || null,
              border:
                (campaign.buttonStrokeColor &&
                  `2px solid ${campaign.buttonStrokeColor}`) ||
                null,
            }}
          >
            {isRegent
              ? "review submission"
              : is1011
                ? "Continue"
                : isConcentrix
                  ? "Confirm and input address"
                  : isCyera ? "Click Here To Claim Your Gift" :
                     isNewGusto ? "Can't wait to see what's inside." : 
                     isPlenty ? "Claim Your Gift" : "go to checkout"}
          </Button>
        )}
      </div>
    </div>
  );
};

export default Gifts;
